export const APP_VERSION = import.meta.env.VITE_APP_VERSION
export const APP_NAME = import.meta.env.VITE_APP_NAME
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL

export const FIREBASE_CONFIG = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
}

export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN
export const POSTHOG_API_KEY = import.meta.env.VITE_POSTHOG_API_KEY
export const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST
export const HYPERDX_API_KEY = import.meta.env.VITE_HYPERDX_API_KEY

export const PRODUCTION_DOMAIN = '.tryloop.ai'

export const COMETCHAT_APP_ID = '2755996af918a2f1'
export const COMETCHAT_REGION = 'US'
export const COMETCHAT_API_KEY = '4fbb00ed185bcfdc6f8d5d9622d308408eb5173b'
